module.exports = __webpack_public_path__ + "cancellara-dist/img/riscatta-salabam.3384ff1f.png";